import CustomerForm from '../components/quote/CustomerForm';
import LineItemList from '../components/quote/LineItemList';
import CheckoutSidebar from '../components/quote/CheckoutSidebar';

export default function StaffCalculator() {
  return (
    <div className="max-w-[1440px] mx-auto px-6 md:px-10 py-8 w-full">
      <div className="flex flex-col gap-2 mb-10 border-l-4 border-primary pl-6">
        <span className="text-primary font-bold tracking-[0.2em] text-xs uppercase font-headline">
          Internal Portal
        </span>
        <h1 className="text-4xl font-extrabold font-headline tracking-tight text-secondary">
          Create a Quotation
        </h1>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
        <div className="lg:col-span-7 flex flex-col gap-8">
          <CustomerForm />
          <LineItemList />
        </div>
        <CheckoutSidebar />
      </div>
    </div>
  );
}
